import { useState, useEffect } from "react";

const useFetchIp = () => {
  const [ip, setIP] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        if (!res.ok) {
          throw new Error("Failed to fetch IP from ipify");
        }
        const data = await res.json();
        setIP(data.ip);
      } catch (error) {
        console.error("Failed to fetch IP", error);
        setError(error);
      }
    };
    fetchIP();
  }, []);

  return { ip, error };
};

export default useFetchIp;
